import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ParentalPinDialUpContainer = styled.div<Props>`
  position: absolute;
  top: ${-120 * Screen.widthRatio}px;
`;

export default ParentalPinDialUpContainer;
